"use strict";

var __spreadArray = this && this.__spreadArray || function (to, from) {
  for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) {
    to[j] = from[i];
  }
  return to;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setSingle = exports.setBool = exports.getSingle = exports.getBool = void 0;
function getBool(_a) {
  var values = _a.values,
    name = _a.name;
  var idx = values.findIndex(function (v) {
    return v.name === name;
  });
  return idx > -1;
}
exports.getBool = getBool;
function getSingle(_a) {
  var values = _a.values,
    name = _a.name;
  var opt = values.find(function (v) {
    return v.name === name;
  });
  return (opt === null || opt === void 0 ? void 0 : opt.choice) || '';
}
exports.getSingle = getSingle;
function setBool(_a) {
  var setValues = _a.setValues,
    values = _a.values,
    name = _a.name,
    checked = _a.checked;
  var nextValues = __spreadArray([], values);
  if (checked) {
    nextValues.push({
      name: name
    });
  } else {
    var idx = values.findIndex(function (v) {
      return v.name === name;
    });
    if (idx > -1) {
      nextValues.splice(idx, 1);
    }
  }
  setValues(nextValues);
  return nextValues;
}
exports.setBool = setBool;
function setSingle(_a) {
  var setValues = _a.setValues,
    values = _a.values,
    name = _a.name,
    choice = _a.choice;
  var nextValues = __spreadArray([], values);
  var idx = values.findIndex(function (v) {
    return v.name === name;
  });
  if (idx === -1) {
    nextValues.push({
      name: name,
      choice: choice
    });
  } else {
    nextValues[idx] = {
      name: name,
      choice: choice
    };
  }
  setValues(nextValues);
  return nextValues;
}
exports.setSingle = setSingle;